import { render, staticRenderFns } from "./HuaxianNewDetail.vue?vue&type=template&id=7341a84d&scoped=true&"
import script from "./HuaxianNewDetail.vue?vue&type=script&lang=js&"
export * from "./HuaxianNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianNewDetail.vue?vue&type=style&index=0&id=7341a84d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7341a84d",
  null
  
)

export default component.exports